import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-navy-900/10 bg-white">
      <div className="mx-auto max-w-7xl container-pad py-10">
        <div className="grid gap-8 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <div className="h-9 w-9 rounded-xl bg-navy-900 text-white flex items-center justify-center font-heading font-bold">
                CA
              </div>
              <div>
                <div className="font-heading font-semibold text-navy-900">Sharma & Co.</div>
                <div className="text-xs text-navy-800/70">Chartered Accountants</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-navy-800/75 max-w-xl">
              Trusted CA services for GST, ITR, registration, ROC, audits, and accounting. WhatsApp-first, mobile-friendly communication built for Indian clients.
            </p>
          </div>

          <div>
            <div className="font-heading text-base text-navy-900">Quick Links</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a className="link" href="#services">Services</a></li>
              <li><a className="link" href="#why">Why Choose Us</a></li>
              <li><a className="link" href="#about">About</a></li>
              <li><a className="link" href="#contact">Contact</a></li>
            </ul>
          </div>

          <div>
            <div className="font-heading text-base text-navy-900">Disclaimer</div>
            <p className="mt-3 text-sm text-navy-800/75">
              Information provided on this website is for general guidance and does not constitute legal or tax advice.
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-navy-900/10 pt-6">
          <div className="text-sm text-navy-800/70">© {year} Sharma & Co. All rights reserved.</div>
          <div className="text-sm text-navy-800/70">
            Built for trust • Mobile-first • WhatsApp-ready
          </div>
        </div>
      </div>
    </footer>
  );
}
